import {
    SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS,
    CLEAR_MEMBER_DETAILS_IO_BLOCKING,
} from '../types';
import { normalizeMemberDetailsIoStatus } from '../utils/memberDetailsIoStatus';

const mapIoRequestStatus = (status) => {
    const normalized = normalizeMemberDetailsIoStatus(status);
    if (normalized === 'valid_offer' || normalized === 'no_offer' || normalized === 'error') {
        return normalized;
    }
    return null;
};

const mapIoDataUpdateStatus = (status) => {
    const normalized = normalizeMemberDetailsIoStatus(status);
    if (normalized === 'success' || normalized === 'error') {
        return normalized;
    }
    return null;
};

const mapUspsValidationStatus = (status) => {
    if (normalizeMemberDetailsIoStatus(status) === 'blocked') {
        return 'blocked';
    }
    return null;
};

const initialState = {
    requestOffers: {
        status: null,
        message: null,
    },
    ioDataUpdate: {
        status: null,
        message: null,
    },
    uspsValidation: {
        status: null,
        message: null,
        target: null,
    },
};

const memberDetails = (state = initialState, action) => {
    switch (action.type) {
        case SYNC_MEMBER_DETAILS_IO_FROM_QUESTIONS: {
            if (!action.payload) {
                return initialState;
            }
            const io = action.payload || {};
            return {
                ...state,
                requestOffers: {
                    status: mapIoRequestStatus(io.requestOffersStatus),
                    message: io.requestOffersMessage || null,
                },
                ioDataUpdate: {
                    status: mapIoDataUpdateStatus(io.ioDataUpdateStatus),
                    message: io.ioDataUpdateMessage || null,
                },
                uspsValidation: (() => {
                    const status = mapUspsValidationStatus(io.uspsValidationStatus);
                    return {
                        status,
                        message: status === 'blocked' ? (io.uspsMessage || null) : null,
                        target: status === 'blocked' ? (io.uspsValidationTarget || null) : null,
                    };
                })(),
            };
        }

        case CLEAR_MEMBER_DETAILS_IO_BLOCKING:
            return {
                ...state,
                uspsValidation: { ...initialState.uspsValidation },
            };

        default:
            return state;
    }
};

export default memberDetails;
